module.exports = __webpack_public_path__ + "site/img/index5.07d11089.png";